import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from '../common/scroll_to_top'
import Home from '../../page/home/home'
import CharactorInfo from '../../page/charactor/charactor_info'
import Minesweeper from '../../page/game/minesweeper/minesweeper'
import PageNotFound from '../../page/error/page_not_found'


const Router = () => {
    return (
        <BrowserRouter>
            <ScrollToTop/>
            <Routes>
                
                <Route path="/" element={<Home />}></Route>
                <Route path="/home" element={<Navigate to="/"></Navigate>}></Route>
                <Route path="/index" element={<Navigate to="/"></Navigate>}></Route>
                <Route path="/index.html" element={<Navigate to="/"></Navigate>}></Route>
                <Route path="/charactor-info/:paramCharactorName" element={<CharactorInfo/>}>
                </Route>
                <Route path="/game/minesweeper" element={<Minesweeper/>}>
                </Route>
                <Route path="/page-not-found" element={<PageNotFound />}></Route>
                <Route path="*" element={<Navigate to="/page-not-found"></Navigate>}></Route>
            </Routes>
        </BrowserRouter>
    )
}

export default Router;